<script setup lang="ts">
import type { OrganizationJs } from "@/generated/models";
import SimpleButton from "ls/components/simple-button/SimpleButton.vue";
import { SimpleDialogContent, SimpleDialogDescription, SimpleDialogFooter, SimpleDialogHeader, SimpleDialogTitle } from "ls/components/simple-dialog";
import { useAccessLevelFromOrganization } from "ls/features/organizations/useOrganizationAccessLevel";
import { useSeatsAndLicensesInfo } from "ls/features/organizations/useSeatsAndLicensesInfo";
import { toOrganizationMembers } from "ls/router/builders";
import { DialogClose } from "reka-ui";
import { computed } from "vue";
import { SubInstanceType } from "@/generated/models";
import OnlineProjectCloudForBusinessStatusContent from "./OnlineProjectCloudForBusinessStatusContent.vue";

const props = defineProps<{
  organization: OrganizationJs;
}>();

const { isAdmin } = useAccessLevelFromOrganization(() => props.organization);
const { cloudAuthorSeatsTotal } = useSeatsAndLicensesInfo(() => props.organization.Id);
const showCloudForBusinessAuthorInfo = computed(() => {
  if (props.organization.Type !== SubInstanceType.SubInstance) return false;
  if (cloudAuthorSeatsTotal.value !== 0) return false;
  return true;
});
</script>

<template>
  <template v-if="showCloudForBusinessAuthorInfo">
    <OnlineProjectCloudForBusinessStatusContent :organization="props.organization" />
  </template>
  <template v-else>
    <SimpleDialogContent>
      <SimpleDialogHeader>
        <SimpleDialogTitle>
          Assign a Cloud Author seat
        </SimpleDialogTitle>
        <SimpleDialogDescription>
          <template v-if="isAdmin">
            To create and edit documents and whiteboards, assign a Cloud Author seat to your account on the members page.
          </template>
          <template v-else>
            To create and edit documents and whiteboards, ask an admin to assign a Cloud Author seat to your account on the members page.
          </template>
        </SimpleDialogDescription>
      </SimpleDialogHeader>
      <SimpleDialogFooter>
        <DialogClose as-child>
          <SimpleButton
            v-if="isAdmin"
            :href="toOrganizationMembers(props.organization)"
            size="large"
          >
            Go to members page
          </SimpleButton>
          <SimpleButton
            v-else
            size="large"
          >
            Got it
          </SimpleButton>
        </DialogClose>
      </SimpleDialogFooter>
    </SimpleDialogContent>
  </template>
</template>
